import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { CheckDuplicate } from 'components/CheckDuplicate';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';

import useAddPage from 'hooks/useAddPage';
const UsersPartnerreisterPage = (props) => {
		const app = useApp();
	const utils = useUtils();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		username: yup.string().required().label("Username"),
		fullname: yup.string().nullable().label("Fullname"),
		phonenumber: yup.string().required().label("Phonenumber"),
		email: yup.string().email().required().label("Email"),
		state: yup.string().nullable().label("State"),
		city: yup.string().nullable().label("City"),
		zipcode: yup.string().nullable().label("Zipcode"),
		address: yup.string().nullable().label("Address"),
		password: yup.string().required().label("Password"),
		confirm_password: yup.string().required().label("Confirm Password").oneOf([yup.ref('password')], "Your passwords do not match"),
		user_role_id: yup.number().nullable().label("User Role Id"),
		profile_photo: yup.string().nullable().label("Profile Photo"),
		account_number: yup.string().nullable().label("Account Number"),
		ifsc_code: yup.string().nullable().label("Ifsc Code")
	});
	
	//form default values
	const formDefaultValues = {
		username: utils.randomStr(5), 
		fullname: '', 
		phonenumber: '', 
		email: '', 
		state: '', 
		city: '', 
		zipcode: '', 
		address: '', 
		password: '', 
		confirm_password: '', 
		user_role_id: "6", 
		profile_photo: '', 
		account_number: '', 
		ifsc_code: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`//users`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="UsersPartnerreisterPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3 mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className=" col " >
                    <Title title="Partner registration"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-4 comp-grid" >
                    <div className="">
                        <div className="flex align-items-center">
                            <div>Already have an account?</div>
                            <div className="ml-2">
                                <Link to="/">
                                    <Button icon="pi pi-user" label="Login" /> 
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <div >
                            <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                                {(formik) => 
                                <>
                                <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                    <div className="grid">
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Username *
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <CheckDuplicate value={formik.values.username} apiPath="components_data/users_username_exist">
                                                    { (checker) => 
                                                    <>
                                                    <InputText name="username" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.username}   label="Username" type="text" placeholder="Enter Username"     disabled   className={inputClassName(formik?.errors?.username)} />
                                                    <ErrorMessage name="username" component="span" className="p-error" />
                                                    {(!checker.loading && checker.exist) && <small className="p-error">Not available</small>}
                                                    {checker.loading && <small className="text-500">Checking...</small> }
                                                    </>
                                                    }
                                                    </CheckDuplicate>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Fullname 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label="Fullname" type="text" placeholder="Enter Fullname"        className={inputClassName(formik?.errors?.fullname)} />
                                                    <ErrorMessage name="fullname" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Phonenumber *
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <CheckDuplicate value={formik.values.phonenumber} apiPath="components_data/users_phonenumber_exist">
                                                    { (checker) => 
                                                    <>
                                                    <InputText name="phonenumber" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.phonenumber}   label="Phonenumber" type="text" placeholder="Enter Phonenumber"        className={inputClassName(formik?.errors?.phonenumber)} />
                                                    <ErrorMessage name="phonenumber" component="span" className="p-error" />
                                                    {(!checker.loading && checker.exist) && <small className="p-error">Not available</small>}
                                                    {checker.loading && <small className="text-500">Checking...</small> }
                                                    </>
                                                    }
                                                    </CheckDuplicate>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Email *
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <CheckDuplicate value={formik.values.email} apiPath="components_data/users_email_exist">
                                                    { (checker) => 
                                                    <>
                                                    <InputText name="email" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.email}   label="Email" type="email" placeholder="Enter Email"        className={inputClassName(formik?.errors?.email)} />
                                                    <ErrorMessage name="email" component="span" className="p-error" />
                                                    {(!checker.loading && checker.exist) && <small className="p-error">Not available</small>}
                                                    {checker.loading && <small className="text-500">Checking...</small> }
                                                    </>
                                                    }
                                                    </CheckDuplicate>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    State 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <DataSource   apiPath="components_data/state_option_list"  >
                                                        {
                                                        ({ response }) => 
                                                        <>
                                                        <Dropdown  name="state"     optionLabel="label" optionValue="value" value={formik.values.state} onChange={formik.handleChange} options={response} label="State"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.state)}   />
                                                        <ErrorMessage name="state" component="span" className="p-error" />
                                                        </>
                                                        }
                                                    </DataSource>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    City 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <DataSource onLoad={(res) => formik.setFieldValue('city', '')} loadOnMount={false} apiPath={`components_data/city_option_list?lookup_state=${formik.values.state}`}  >
                                                        {
                                                        ({ response }) => 
                                                        <>
                                                        <Dropdown  name="city"     optionLabel="label" optionValue="value" value={formik.values.city} onChange={formik.handleChange} options={response} label="City"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.city)}   />
                                                        <ErrorMessage name="city" component="span" className="p-error" />
                                                        </>
                                                        }
                                                    </DataSource>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Zipcode 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <InputText name="zipcode"  onChange={formik.handleChange}  value={formik.values.zipcode}   label="Zipcode" type="text" placeholder="Enter Zipcode"        className={inputClassName(formik?.errors?.zipcode)} />
                                                    <ErrorMessage name="zipcode" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-12 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Address 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <InputText name="address"  onChange={formik.handleChange}  value={formik.values.address}   label="Address" type="text" placeholder="Enter Address"        className={inputClassName(formik?.errors?.address)} />
                                                    <ErrorMessage name="address" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Password *
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <Password name="password" value={formik.values.password} onChange={formik.handleChange} label="Password" placeholder="Enter Password"  inputClassName="w-full" toggleMask feedback className={inputClassName(formik?.errors?.password)} />
                                                    <ErrorMessage name="password" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Confirm Password *
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <Password name="confirm_password" id="confirm_password" className={inputClassName(formik?.errors?.comfirm_password)} inputClassName="w-full" feedback={false} toggleMask  value={formik.values.confirm_password} onChange={formik.handleChange} label="Confirm Password" placeholder="Confirm Password"  />
                                                    <ErrorMessage name="confirm_password" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    User Role Id 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <InputText name="user_role_id"  onChange={formik.handleChange}  value={formik.values.user_role_id}   label="User Role Id" type="number" placeholder="Enter User Role Id"  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.user_role_id)} />
                                                    <DataSource   apiPath="components_data/user_role_id_option_list"  >
                                                        {
                                                        ({ response }) => 
                                                        <>
                                                        <datalist id="user_role_id_list">
                                                        { response.map((option, index)=> <option key={index} value={option.value}>{option.label}</option>)}
                                                        </datalist>
                                                        </>
                                                        }
                                                    </DataSource>
                                                    <ErrorMessage name="user_role_id" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="md:col-6 col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Profile Photo 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <div className={inputClassName(formik?.errors?.profile_photo)}>
                                                        <Uploader name="profile_photo" showUploadedFiles value={formik.values.profile_photo} uploadPath="fileuploader/upload/profile_photo" onChange={(paths) => formik.setFieldValue('profile_photo', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                    </div>
                                                    <ErrorMessage name="profile_photo" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Account Number 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <InputText name="account_number"  onChange={formik.handleChange}  value={formik.values.account_number}   label="Account Number" type="text" placeholder="Enter Account Number"        className={inputClassName(formik?.errors?.account_number)} />
                                                    <ErrorMessage name="account_number" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="formgrid grid">
                                                <div className="col-12 md:col-3">
                                                    Ifsc Code 
                                                </div>
                                                <div className="col-12 md:col-9">
                                                    <InputText name="ifsc_code"  onChange={formik.handleChange}  value={formik.values.ifsc_code}   label="Ifsc Code" type="text" placeholder="Enter Ifsc Code"        className={inputClassName(formik?.errors?.ifsc_code)} />
                                                    <ErrorMessage name="ifsc_code" component="span" className="p-error" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    { props.showFooter && 
                                    <div className="text-center my-3">
                                        <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                    </div>
                                    }
                                </Form>
                                </>
                                }
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
		);
	}
}

//page props and default values
UsersPartnerreisterPage.defaultProps = {
	primaryKey: 'userid',
	pageName: 'users',
	apiPath: 'users/partnerreister',
	routeName: 'userspartnerreister',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default UsersPartnerreisterPage;
